export default __webpack_public_path__ + "assets/bob-w-horizontal-logo-brown.6370f588bcd4cf26a3a045149c02695d.svg";